
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestcardprocessingrates",
      function () {
        return require("private-next-pages/bestcardprocessingrates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestcardprocessingrates"])
      });
    }
  